<template>
  <div id="app" class="page-container">
    <router-view :key="activeDate"/>
  </div>
</template>

<script>
// mixins
import shareMixin from './mixins/share'

export default {
  name: 'App',
  mixins: [shareMixin],
  watch: {
    $route: {
      handler (to, from) {
        this.activeDate = new Date().getTime()
        if (!/searching/.test(to.path)) {
          this.updateWeixinShareConfig()
        }
        gtag('config', 'UA-19521615-15', {
          page_title: to.path.replace(/\/(\w+)$/, '$1_page'),
          page_path: to.full_path
        })
      },
      immediate: true
    }
  },
  mounted () {
    window.onpopstate = (event) => {
      console.log(event.state)
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  list-style: none;
}
input[type=button], input[type=search], button {
  -webkit-appearance: none;
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #fff;
}
.page-container {
  min-height: 100vh;
  min-width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/App.vue